import React, { useMemo } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { TableResponsive } from '../../../components/common/TableResponsive';
import { useStatusEnquiry, StatusEnquiryHeader } from './StatusEnquiry/index';
import { getEnquiryColumns } from './EnquiryList/enquiryColumns';
import './EnquiryList/EnquiryList.css';

const NotInterestedEnquiry = () => {
    const {
        enquirys,
        totalCount,
        districtList,
        selectedDistrict,
        setSelectedDistrict,
        isLoading,
        authData,
        searchTerm,
        setSearchTerm,
        handleEnquiryDelete,
        handleReport
    } = useStatusEnquiry('deleted');

    const columns = useMemo(
        () =>
            getEnquiryColumns({
                authData,
                enquirys,
                handleEnquiryDelete,
                handleReport
            }),
        [authData, enquirys, handleEnquiryDelete, handleReport]
    );

    return (
        <>
            <BreadCrumb title="Not Interested" prevPage="Enquiry" prevPath="/enquiry" />
            <Row>
                <Col xs={12}>
                    <Card className="border-0 shadow-sm">
                        <StatusEnquiryHeader
                            title="Not Interested / Dropped Leads"
                            subtitle="Enquiries where candidate or school is currently not interested"
                            icon="ri-close-circle-line"
                            badgeColor="danger"
                            badgeLabel="Total Dropped"
                            count={totalCount}
                            districtList={districtList}
                            selectedDistrict={selectedDistrict}
                            setSelectedDistrict={setSelectedDistrict}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={enquirys}
                                noRecord="No Not-Interested Enquiries Found"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default NotInterestedEnquiry;
